import { render, staticRenderFns } from "./ylxdsqDetail.vue?vue&type=template&id=579885f4&scoped=true&"
import script from "./ylxdsqDetail.vue?vue&type=script&lang=ts&"
export * from "./ylxdsqDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ylxdsqDetail.vue?vue&type=style&index=0&id=579885f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579885f4",
  null
  
)

export default component.exports